import { render, staticRenderFns } from "./ReadNews.vue?vue&type=template&id=2657bf7f&scoped=true&"
import script from "./ReadNews.vue?vue&type=script&lang=js&"
export * from "./ReadNews.vue?vue&type=script&lang=js&"
import style0 from "./ReadNews.vue?vue&type=style&index=0&id=2657bf7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2657bf7f",
  null
  
)

export default component.exports